import { render, staticRenderFns } from "./SellerView.vue?vue&type=template&id=1b54db27"
import script from "./SellerView.vue?vue&type=script&lang=js"
export * from "./SellerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports